// Promise-based confirmation dialog, replacing window.confirm(). The dialog
// itself is <ConfirmDialog />, mounted once in App.vue.
//
//   import { confirmAction } from '@/utils/confirm';
//   const ok = await confirmAction({
//       title: 'Mark This Bid as Won?',
//       message: 'It moves to Active Projects and project tracking starts.',
//       confirmLabel: 'Mark as Won',
//   });
//   if (!ok) return;
//
// Per Apple's alert guidance: the confirm button names the action (never
// "OK" / "Yes"), Cancel is always there, and `destructive: true` styles the
// confirm button red for actions that remove or discard something.
import { reactive } from 'vue';

export const confirmState = reactive({
    open: false,
    title: '',
    message: '',
    confirmLabel: 'Continue',
    cancelLabel: 'Cancel',
    destructive: false,
    resolve: null,
});

export function confirmAction({ title, message = '', confirmLabel = 'Continue', cancelLabel = 'Cancel', destructive = false }) {
    // A second request while one is open cancels the first.
    if (confirmState.resolve) confirmState.resolve(false);
    return new Promise((resolve) => {
        Object.assign(confirmState, { open: true, title, message, confirmLabel, cancelLabel, destructive, resolve });
    });
}

export function settleConfirm(result) {
    const resolve = confirmState.resolve;
    confirmState.open = false;
    confirmState.resolve = null;
    if (resolve) resolve(result);
}
